import React from 'react';

const SvgBagPlus = ({ color, ...props})=> (
  <svg width="18" viewBox="0 0 18 18" {...props}>
    <path
      d="M15.2 5.44C14.649 2.75 12.037 0 9 0a6.725 6.725 0 0 0-6.239 5.44H-.01V18h18.024V5.44H15.2zM9 1.78c2.036 0 3.8 1.87 4.338 3.66H4.58A4.859 4.859 0 0 1 9 1.78zm7.209 14.43H1.792V7.23h14.419v8.98zm-8.11-3.59h-1.8v-1.8h1.8V9.03h1.8v1.79h1.8v1.8h-1.8v1.79h-1.8v-1.79z"
      fill={color || "currentColor"}
      fillRule="evenodd"
    />
  </svg>
);

export default SvgBagPlus;
